import { toast } from 'react-toastify';
import { BooleanText } from '../shared/constants';
import { ToastParameters } from '../types/shared';
import { toastAutoCloseDelay } from './constants';

export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

export function getDefaultLoadingMessage(thing: string): string {
  return `Loading ${thing}...`;
}
export function getDefaultLoadingErrorMessage(thing: string): string {
  return `There was an error loading ${thing}.`;
}
export function getDefaultNotFoundMessage(things: string): string {
  return `No ${things} were found.`;
}

/**
 * Display React Toastify
 * @description Typed, borrowed from `toastFn`
 * @param {ToastParameters} toastParams
 */
export function showToast({ reason = '', message = '', id, autoClose = false }: ToastParameters) {
  if (!id || !toast.isActive(id)) {
    if (reason) {
      (toast as any)[reason](message, {
        toastId: id,
        autoClose: autoClose ? autoClose : toastAutoCloseDelay,
      });
    } else {
      toast(message, { toastId: id, autoClose: autoClose ? autoClose : toastAutoCloseDelay });
    }
  }
}

/**
 * Display React Toastify Success Toast
 * @description Helper
 * @param {ToastParameters} toastParams
 */
export function showToastSuccess({
  message = '',
  id,
  autoClose = false,
}: Omit<ToastParameters, 'reason'>) {
  showToast({ reason: 'success', message, id, autoClose });
}

/**
 * Display React Toastify Erroe Toast
 * @description Helper
 * @param {ToastParameters} toastParams
 */
export function showToastError({
  message = '',
  id,
  autoClose = false,
}: Omit<ToastParameters, 'reason'>) {
  showToast({ reason: 'error', message, id, autoClose });
}

export function showUnauthorizedToast(requestUrl = '') {
  const path = requestUrl.split('?')[0].replace(/\/$/, '').toLowerCase();
  // Anonymous session discovery is expected when opening the login page.
  if (path.endsWith('/auth/gettokeninfo')) {
    return;
  }
  showToastError({
    message: 'Unauthorized / session expired.',
    id: 'unauthorized-session-expired',
    autoClose: 5000,
  });
  window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
}

export function getBooleanText(testValue: boolean | string | number) {
  return testValue ? BooleanText.TRUE : BooleanText.FALSE;
}
